module.exports = __webpack_public_path__ + "img/points.02e74b84.svg";